import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Lmh1b3BlcDAgewogIGJvcmRlci1zdHlsZTogc29saWQ7CiAgYm9yZGVyLXdpZHRoOiAxcHggMCAwIDA7CiAgYm9yZGVyLWNvbG9yOiAjREJEREU0Owp9';
export var listItemWrapperStyle = 'huopep0';